import _readOnlyError from "/app/node_modules/@babel/runtime/helpers/esm/readOnlyError.js";
import _callSuper from "/app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createClass from "/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _defineProperty from "/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.values.js";
import { __decorate } from "tslib";
import { Options, Vue } from 'vue-class-component';
import Card from '@/components/layout/Card.vue';
import store from '@/store';
import { router } from "@/router";
var PlatformFull = /*#__PURE__*/_createClass(function PlatformFull(platform, summary) {
  _classCallCheck(this, PlatformFull);
  _defineProperty(this, "platform", void 0);
  _defineProperty(this, "summary", void 0);
  this.platform = platform;
  this.summary = summary;
});
var PlatformsTable = /*#__PURE__*/function (_Vue) {
  function PlatformsTable() {
    _classCallCheck(this, PlatformsTable);
    return _callSuper(this, PlatformsTable, arguments);
  }
  _inherits(PlatformsTable, _Vue);
  return _createClass(PlatformsTable, [{
    key: "platformsFull",
    get: function get() {
      // on join each summary in the platorm
      var platforms = Object.values(store.getters.platforms);
      var platformFulls = [];
      for (var i in platforms) {
        if (platforms[i] !== undefined) {
          var platform = platforms[i];
          var summary = store.getters.summary(platform);
          if (summary !== undefined) {
            platformFulls.push(new PlatformFull(platforms[i], summary));
          }
        }
      }
      return platformFulls;
    }
  }, {
    key: "goToTheLine",
    value: function goToTheLine(line) {
      router.push({
        name: 'platformDetail',
        params: {
          platformID: line.platform.platformID,
          name: line.platform.name
        }
      });
    }
  }, {
    key: "summary",
    value: function summary(platform) {
      var summary = store.getters.summary(platform);
      return store.getters.summary(platform);
    }
  }]);
}(Vue);
PlatformsTable = __decorate([Options({
  components: {
    Card: Card
  }
})], PlatformsTable);
export default PlatformsTable;